<template>
  <form @submit.prevent="save">
    <div class="nk-block">
      <div class="nk-block-head">
        <h5 class="title">Contratos</h5>
        <p></p>
      </div><!-- .nk-block-head -->
      <div v-if="!contratos.length" class="alert alert-info">
        <p>Aún no se ha añadido ningún contrato, da clic en <b>Agregar Contrato</b> para añadir uno.</p>
      </div>
      <div v-for="contrato in contratos" :key="contrato.id_contrato" class="row">
        <div class="col-12 d-flex align-items-end justify-content-end">
          <button type="button" class="btn btn-outline-danger" @click.prevent="remove(contrato)">Eliminar registro</button>
        </div>
        <div class="col-sm-6">
          <div class="form-group">
            <label class="form-label">Fecha del Contrato</label>
            <input type="date" class="form-control" v-model.lazy="contrato.fecha">
          </div>
        </div>
        <div class="col-sm-6 mt-3">
          <div class="form-group">
            <label class="form-label">Contrato</label>
            <Uploader :preFiles="$filters.getFiles(contrato.f_contrato?.id_archivo)" :server="$filters.getServer(model)" v-model:file="contrato.f_contrato"></Uploader>
          </div>
        </div>
      </div>
      <div class="w-100 text-right">
        <button type="button" class="mt-2 btn btn-lg btn-info" @click.prevent="add">Agregar Contrato</button>
      </div>
    </div><!-- .nk-block -->
  </form>
</template>

<script>
import {useApi} from "@/use/useApi";
import {reactive, toRefs, defineComponent, computed, watch} from 'vue';
import { useRouter } from 'vue-router';
import Swal from "sweetalert2";
import Uploader from "@/components/globales/Uploader";
const { v4: uuidv4 } = require('uuid');

export default defineComponent({
  name: "ContratosEmpleado",
  components: {
    Uploader
  },
  props: ['empleado'],
  setup(params) {
    //Data
    const { loading, make } = useApi();
    const router = useRouter();

    const model = computed(()=>{
      return params.empleado;
    });

    const state = reactive({
      contratos: [],
      inited: false
    });

    //Methods
    async function get(){
      loading.message = 'Obteniendo información';
      let {data} = await make('empleados/contratos/get', {id_empleado: model.value.id_empleado});
      if(data === null){
        await Swal.fire('Error', 'Ocurrió un error al conectarse con el servidor', 'error');
        router.go();
      } else {
        if(data.error){
          await Swal.fire('Error', data.message, 'error');
        } else {
          state.contratos = data.contratos;
        }
      }
    }

    async function save(){
      loading.message = 'Actualizando información';
      //Save
      let {data} = await make('empleados/contratos/edit', {model: state.contratos, id_empleado: model.value.id_empleado});
      if(data === null){
        await Swal.fire('Error', 'Ocurrió un error al conectarse con el servidor', 'error');
      } else {
        if(data.error){
          await Swal.fire('Error', data.message, 'error');
        }
      }
    }

    function add() {
      state.contratos.push({
        id_contrato: uuidv4(),
        fecha: null,
        f_contrato: {
          id_archivo: false,
          estatus: 'Pendiente',
          url: '#',
          autorizo: '',
          subio: '',
          nombre: ''
        }
      });
    }

    function remove(contrato){
      state.contratos = state.contratos.filter(_contrato => _contrato.id_contrato !== contrato.id_contrato);
    }

    watch(() => state.contratos, () => {
      if(state.inited){
        save();
      } else {
        state.inited = true;
      }
    }, {deep: true});

    get();

    return {model, ...toRefs(state), loading, save, get, add, remove};
  }
});
</script>

<style scoped>
  textarea.form-control {
    min-height: 75px;
  }
  .form-label {
    text-transform: uppercase;
  }
</style>